import { StyleSheet } from 'aphrodite';
import { CssSelectors } from '../../../../web/styles/styles';
import { brandPrimary, brandSecondary, white } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	chips: {
		padding: `0 !important`,
		border: 0,
		boxShadow: 'none',
		minHeight: 0,
	},
	searchIcon: {
		width: 12,
		height: 12,
		marginRight: 4,
	},
	filterDropdownTrigger: {
		background: brandPrimary,
		border: `1px solid ${brandSecondary}`,
		borderRadius: 3,
		color: white,
		width: 240,
	},
	autocomplete: {
		...CssSelectors.allDescendants(
			{
				background: brandPrimary,
				border: `1px solid ${brandSecondary}`,
				borderRadius: 3,
				...CssSelectors.allDescendants(
					{
						color: white,
						width: 240,
					},
					'input'
				),
			},
			'.common-autocomplete .autocomplete-search-field-input'
		),
		...CssSelectors.allDescendants(
			{
				fill: white,
				opacity: 0,
			},
			'.common-autocomplete-clear-button circle'
		),
		...CssSelectors.allDescendants(
			{
				fill: white,
			},
			'.common-autocomplete-search-icon path'
		),
	},
});
